<template>
  <div class="msgtypeNews">
    <div class="msgtypeNews_box">
      <p v-for="(item, index) in items.content.item" :key="index">
        <span>{{ item.content.title }}</span>
        <i>{{ item.content.description }}</i>
        <img alt="" :src="item.content.picurl" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      proportion: false,
    };
  },
  mounted() {
    const imgObj = new Image();
    imgObj.src = this.items.cos_file_url;
    imgObj.onload = () => {
      if (imgObj.width > imgObj.height) {
        this.proportion = true;
      }
    };
  },
};
</script>

<style scoped lang="scss">
.msgtypeNews {
  border-radius: 8px;
  padding: 0 12px;
  box-sizing: border-box;
  .msgtypeNews_box {
    width: 134px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 12px;
    box-sizing: border-box;
    span {
      font-size: 16px;
      color: #303133;
      line-height: 28px;
    }
    i {
      font-size: 14px;
      color: #909399;
      line-height: 24px;
    }
    img {
      width: 110px;
      height: 124px;
      border-radius: 4px;
      font-size: 0;
    }
  }
}
</style>
